import React from "react";
import { CtaPair } from "./CtaPair";
type CtaBandProps = {
  title: string;
  text: string;
  quoteLabel?: string;
};
export function CtaBand({
  title,
  text,
  quoteLabel
}: CtaBandProps) {
  return <section className="bg-rinnai py-8 text-white lg:py-10" aria-labelledby="cta-band-title" data-id="element-20" data-mp="hgvuq1r11k5j">
      <div className="mx-auto grid max-w-[1320px] items-center gap-8 px-5 lg:grid-cols-[1.15fr_0.85fr] lg:px-10" data-id="element-21" data-mp="mgrqxethg7aj">
        <div data-id="element-22" data-mp="rea118j8ksk4">
          <h2 id="cta-band-title" className="text-3xl font-bold tracking-[-0.04em] sm:text-4xl" data-id="element-23" data-mp="retiko4z5exm">{title}</h2>
          <p className="mt-3 text-white/85" data-id="element-24" data-mp="vfdbffiilwdy">{text}</p>
        </div>
        <CtaPair tone="dark" quoteLabel={quoteLabel} data-id="element-25" data-mp="107d9f2f0yf7w" />
      </div>
    </section>;
}